module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-44-e022026eae6cb64d7751c5142ccd9e65.svg";